import axios from "../axiosConfig";

class Routes {
  getAllUsers = () => {
    let data = axios.get("/api/user/get");
    return data;
  };

  getAssignedProjects = (id) => {
    let data = axios.get(`/api/user/assign-projects`);
    return data;
  };
  getAssignedProjectsById = (id) => {
    let data = axios.get(`/api/user/assign-projects-by-id/${id}`);
    return data;
  };
  getUserById = (id) => {
    let data = axios.get(`/api/user/`);
    return data;
  };
  createUser = (val) => {
    let data = axios.post("/api/user/create", val);
    return data;
  };
  updateUser = (val) => {
    let data = axios.post("/api/user/update", val);
    return data;
  };
  assignProjectToUser = (val) => {
    let data = axios.post("/api/user/assign-projects", val);
    return data;
  };

  deleteUser = (id) => {
    const data = axios.delete(`/api/user/delete/${id}`);
    return data;
  };

  // get admin dashboard data
  getAdminDashboardData = () => {
    const data = axios.get("/api/user/admin/dashboard");
    return data;
  };
  getUserDashboardData = () => {
    const data = axios.get("/api/user/dashboard");
    return data;
  };
  createTimeSheet = ({
    rows,
    notes,
    weekStart,
    weekEnd,
    totalHours,
    userId,
    groupId,
    isSubmited
  }) => {
    let data = axios.post("/api/time-entry/create-time-sheet", {
      userId,
      rows,
      notes,
      weekStart,
      weekEnd,
      totalHours,
      groupId,
      isSubmited
    });
    return data;
  };
  updateTimeSheet = ({
    id,
    rows,
    notes,
    weekStart,
    weekEnd,
    totalHours,
    userId,
    groupId,
    isSubmited
  }) => {
    let data = axios.put("/api/time-entry/edit-timesheet", {
      userId,
      id,
      rows,
      notes,
      weekStart,
      weekEnd,
      totalHours,
      groupId,
      isSubmited
    });
    return data;
  };
  // get-time-sheet
  getYourTimeSheet = () => {
    const data = axios.get(`/api/time-entry/get-your-time-sheet`);
    return data;
  };

  // get-time-sheet
  getAdminTimeSheet = (id) => {
    const data = axios.get(`/api/time-entry/get-time-sheet/${id}`);
    return data;
  };

  // approveTimeSheet = (id) => {
  //   const data = axios.post(`/api/time-entry/approve-time-sheet/${id}`);
  //   return data;
  // };

  approveTimeSheet = (id, status) => {
    const data = axios.post(`/api/time-entry/approve-time-sheet/${id}`, {
      status: status,
    });
    return data;
  };

  // Submit a user's timesheet for approval (admin): get timesheet then update with isSubmited: true
  submitTimeSheet = async (userId, weekStart, weekEnd) => {
    const response = await this.getTimeSheetByPayload({ userId, weekStart, weekEnd });
    const data = response?.data;
    if (!data || !data.id) throw new Error("Timesheet not found");
    const payload = {
      userId: data.userId ?? userId,
      id: data.id,
      rows: typeof data.rows === "string" ? JSON.parse(data.rows) : (data.rows || []),
      notes: data.notes || "",
      weekStart: data.weekStart || weekStart,
      weekEnd: data.weekEnd || weekEnd,
      totalHours: data.totalHours || 0,
      groupId: data.groupId || null,
      isSubmited: true,
    };
    return axios.put("/api/time-entry/edit-timesheet", payload);
  };

  // dashboard
  getUserDashboard = () => {
    const data = axios.get(`/api/user/dashboard`);
    return data;
  };
  getTimeSheetByPayload = async (submissionDetails) => {
    try {
      const response = await axios.post(
        `/api/time-entry/get-timesheet-byPayload`,
        submissionDetails,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response.data;
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      throw error;
    }
  };
  getReportByProject = (selectedFilter) => {
    const response = axios.get(`/api/report/get-report`, selectedFilter);
    return response;
  };


  // changePassword
  changePassword = (val) => {
    let data = axios.post("/api/user/change-password", val);
    return data;
  };
  // get time sheet report for all 
  getAllUserTimeSheetByPayload = async (data) => {
    try {
      const response = await axios.post(
        "api/time-entry/view-weekly-timesheet",
        { weekStart: data },
        { headers: { "Content-Type": "application/json" } }
      );
      return response.data;
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      throw error;
    }
  };

}

export default new Routes();
